import { runtimeConfig } from '@src/core/runtime-config'
import * as Sentry from '@sentry/angular'

if (runtimeConfig.sentry.dsn) {
  Sentry.init({
    dsn: runtimeConfig.sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
